import { api } from "./core";

export const stressApi = {
  get(taskId) {
    return api(`/api/stress/${encodeURIComponent(taskId)}`);
  },
};
